import React, { createContext, ReactNode, useContext, useState } from "react";
import { Oval } from "react-loader-spinner"; // Importar o loader
import Modal from "react-modal"; // Importar modal

import Typography from "@mui/material/Typography"; // Importar Typography do Material UI
import LogoSinsoft from "../Assets/Logo.png"; // Importar logo
import theme from "../Styles/theme";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
    background: theme.colors.light,
    border: "none",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.40)",
    zIndex: 1000,
  },
};

interface ILoaderContextData {
  loading: boolean;
  mensagem: string;
  porcentagem: number;
  showLoader: (msg?: string, percent?: number) => void;
  hideLoader: () => void;
  teste: () => void;
  setMensagem: React.Dispatch<React.SetStateAction<string>>;
  setPorcentagem: React.Dispatch<React.SetStateAction<number>>;
}

const LoaderContext = createContext({} as ILoaderContextData);

interface ILoaderProviderProps {
  children: ReactNode;
}

function LoaderProvider({ children }: ILoaderProviderProps) {
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [porcentagem, setPorcentagem] = useState(0);

  const showLoader = (msg = "", percent = 0) => {
    setMensagem(msg);
    setPorcentagem(percent);
    setLoading(true);
  };
  const teste = () => {
    setMensagem("TESTE");
    setPorcentagem(50);
    setLoading(true);
  };

  const hideLoader = () => {
    setLoading(false);
    setMensagem("");
    setPorcentagem(0);
  };

  return (
    <LoaderContext.Provider
      value={{
        loading,
        mensagem,
        porcentagem,
        showLoader,
        hideLoader,
        setMensagem,
        setPorcentagem,
        teste
      }}
    >
      {children}
      {/* Loader embutido diretamente no Provider */}
      {loading && (
        <Modal
          isOpen={loading}
          onRequestClose={hideLoader}
          style={customStyles}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent:"center",
             
            }}
          >
            {mensagem && (
              <Typography
                variant="h6"
                style={{
                  marginBottom: "1rem",
                  color: theme.colors.primary,
                  textAlign: "center",
                }}
              >
                {mensagem}
              </Typography>
            )}

            <img
              src={LogoSinsoft}
              alt="Logo Sinsoft"
              style={{ marginBottom: "1rem" }}
            />

            <Oval
              width={"max(3vw, 30px)"}
              height={"max(3vw, 30px)"}
              color={theme.colors.primary}
              secondaryColor={theme.colors.texto}
            />

            <Typography
              variant="body2"
              style={{ marginTop: "1rem", color: theme.colors.primary }}
            >
              Conclusão: {porcentagem}%
            </Typography>
          </div>
        </Modal>
      )}
    </LoaderContext.Provider>
  );
}

function useLoader() {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoader must be used within a LoaderProvider");
  }
  return context;
}

export { LoaderProvider, useLoader };
